import { FormTextField } from '@nextiva/engagement-ui';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import cx from 'classnames';
import uuid from 'uuid/v4';

import propTypeStyleTextfieldInner from 'styling/config/editorBlock/PropTypes/styleTextfieldInner';
import propTypeStyleTextfieldOuter from 'styling/config/editorBlock/PropTypes/styleTextfieldOuter';
import StylingToCSSTextfieldInner from 'styling/hocs/StylingToCSS/StylingToCSSTextfieldInner';
import StylingToCSSTextfieldOuter from 'styling/hocs/StylingToCSS/StylingToCSSTextfieldOuter';
import toCSS from 'utils/toCSS';

class FormTextFieldWithStyleInline extends Component {
  static propTypes = {
    className: PropTypes.string,
    styleTextfieldInner: propTypeStyleTextfieldInner,
    styleTextfieldOuter: propTypeStyleTextfieldOuter,
  };

  blockInstanceClassName = 'textfield-' + uuid();

  render() {
    const {
      className,
      styleTextfieldInner,
      styleTextfieldOuter,
      ...props
    } = this.props;

    return (
      <Fragment>
        <style type="text/css">
          {`.${this.blockInstanceClassName} .textfield-outer`}
          {toCSS(styleTextfieldOuter)}
          {`.${this.blockInstanceClassName} input`}
          {toCSS(styleTextfieldInner)}
        </style>

        <FormTextField
          className={cx(className, this.blockInstanceClassName)}
          componentClassName="textfield-outer"
          {...props}
        />
      </Fragment>
    );
  }
}

export default compose(
  StylingToCSSTextfieldInner,
  StylingToCSSTextfieldOuter,
)(FormTextFieldWithStyleInline);
